module.exports = __webpack_public_path__ + "img/elvis-fanday-85.69acd1df.jpg";